import Breadcrumbs from 'components/common/Breadcrumbs';
import ListItems from 'components/common/ListItems';
import PropertyStatusWrapper from 'components/common/PropertyStatusWrapper';
import TopBar from 'components/common/TopBar';
import React, { useEffect } from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { AppState } from 'store';
import { doFetchChatByTilstandsrapportId } from 'store/chat/actions';
import { getChat } from 'store/chat/selectors';
import { TGCount } from 'store/commonTypes';

import {
  makeGetTgCounts,
  getCriticalSjekkpunkterIds,
  getOtherSjekkpunkterIds,
  getIsWebtakst,
  getAllSjekkpunkterIds,
  getAddress,
} from 'store/tilstandsrapportEntities/tilstandsrapport/selectors';

import { doFetchReads, } from 'store/user/read/actions';
import { getHasFetchedReadsForTilstandsrapportId } from 'store/user/read/selectors';
import styles from './styles.scss';

interface Props {
  tilstandsrapportId: string;
}

interface StateProps {
  spCriticalIds: string[];
  spOtherSjekkpunkterIds: string[];
  spAllSjekkpunkterIds: string[];
  isWebtakst: boolean;
  tgCount: TGCount;
  address: string;
  chat: any;
  hasFetchedReadsForTilstandsrapportId: boolean;
}

interface DispatchProps {
  doFetchReads: Function;
  doFetchChatByTilstandsrapportId: Function;
}

const ReportList = ({
  tgCount,
  spCriticalIds,
  spOtherSjekkpunkterIds,
  spAllSjekkpunkterIds,
  tilstandsrapportId,
  isWebtakst,
  address,
  hasFetchedReadsForTilstandsrapportId,
  doFetchReads: fetchReads,
  doFetchChatByTilstandsrapportId: fetchChatByTilstandsrapportId,
  chat,
}: Props & StateProps & DispatchProps): JSX.Element => {

  useEffect(() => {
    if (!hasFetchedReadsForTilstandsrapportId) {
      fetchReads(tilstandsrapportId)
    };
    fetchChatByTilstandsrapportId(tilstandsrapportId);
  }, [tilstandsrapportId]);
  return (
    <>
      {/* Used for tracking purposes */}
      <div data-num-sjekkpunkter={spAllSjekkpunkterIds.length} />

      <div className={styles.breadcrumbsContainer}>
        <Breadcrumbs links={[
          { href: `/${tilstandsrapportId}`, title: address },
          { href: `/${tilstandsrapportId}/utbedringsplan`, title: 'Utbedringsplan' },
        ]} />
      </div>

      <TopBar
        title={address}
        backButtonHref={`/overview?tilstandsrapportId=${tilstandsrapportId}`}
        backButtonAs={`/${tilstandsrapportId}`}
      />
      <div className={styles.propertyStatusWrapperContainer}>
        <PropertyStatusWrapper
          tg1Count={tgCount.tg1}
          tg2Count={tgCount.tg2}
          tg3Count={tgCount.tg3}
          className={styles.propertyStatusWrapper}
        />
      </div>
      <div className={styles.container}>
        {!isWebtakst ? (
          <>
            <ListItems
              tilstandsrapportId={tilstandsrapportId}
              header="De viktigste punktene"
              subtitle="Se tilstandsrapporten for mer informasjon!"
              missingText="Ingen sjekkpunkter funnet"
              sjekkpunkter={spCriticalIds}
              chat={chat}
            />
            <ListItems
              tilstandsrapportId={tilstandsrapportId}
              header="Andre sjekkpunkter"
              subtitle="Se tilstandsrapporten for mer informasjon!"
              missingText="Ingen sjekkpunkter funnet"
              sjekkpunkter={spOtherSjekkpunkterIds}
              chat={chat}
            />
          </>
        ) : (
          <ListItems
            tilstandsrapportId={tilstandsrapportId}
            header="Sjekkpunkter"
            subtitle="Se tilstandsrapporten for mer informasjon!"
            missingText="Ingen sjekkpunkter funnet"
            sjekkpunkter={spAllSjekkpunkterIds}
            chat={chat}
          />
        )}
      </div>
    </>
  );
};

const makeMapStateToProps = (): MapStateToProps<StateProps, Props, AppState> => {
  const getTgCounts = makeGetTgCounts();
  return (state: AppState, ownProps: Props): StateProps => ({
    hasFetchedReadsForTilstandsrapportId: getHasFetchedReadsForTilstandsrapportId(state, ownProps.tilstandsrapportId),
    tgCount: getTgCounts(state, ownProps.tilstandsrapportId),
    spCriticalIds: getCriticalSjekkpunkterIds(state, ownProps.tilstandsrapportId),
    spOtherSjekkpunkterIds: getOtherSjekkpunkterIds(state, ownProps.tilstandsrapportId),
    spAllSjekkpunkterIds: getAllSjekkpunkterIds(state, ownProps.tilstandsrapportId),
    isWebtakst: getIsWebtakst(state, ownProps.tilstandsrapportId),
    address: getAddress(state, ownProps.tilstandsrapportId),
    chat: getChat(state).data,
  });
};

export default connect<StateProps, DispatchProps, Props>(
  makeMapStateToProps,
  {
    doFetchReads,
    doFetchChatByTilstandsrapportId,
  },
)(ReportList);
